import { IconWrapper } from '../runtime';
export default IconWrapper('electronic-pen', true, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 48 48",
      "fill": "none"
    }
  }, [h("g", {
    "attrs": {
      "clip-path": 'url(#' + props.id + '49e6bff9' + ')'
    }
  }, [h("rect", {
    "attrs": {
      "x": "35.1926",
      "y": "5.32227",
      "width": "12",
      "height": "38",
      "rx": "6",
      "transform": "rotate(45 35.1926 5.32227)",
      "fill": props.colors[1],
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth
    }
  }), h("path", {
    "attrs": {
      "d": "M18 23L26 31",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("path", {
    "attrs": {
      "d": "M6 43L12 37",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("rect", {
    "attrs": {
      "x": "33.2681",
      "y": "12.3396",
      "width": "4",
      "height": "4",
      "rx": "2",
      "transform": "rotate(30 33.2681 12.3396)",
      "fill": props.colors[2]
    }
  })]), h("defs", [h("clipPath", {
    "attrs": {
      "id": props.id + '49e6bff9'
    }
  }, [h("rect", {
    "attrs": {
      "width": "48",
      "height": "48",
      "fill": props.colors[2]
    }
  })])])]);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@icon-park/vue/es/icons/ElectronicPen.js
// module id = null
// module chunks = 